import React from 'react';
import FontAwesome from 'react-fontawesome';
import PhotoContainer from '../../PhotoContainer';

const Changes = ({ changeRequests }) => {
  if (changeRequests && changeRequests.length) {
    let names = [];
    changeRequests.forEach((u) => {
      names.push(u.userNames);
    });
    let nameList = names.join(', ');

    return (
      <div className="change-request">
        <FontAwesome name="close" />
        {changeRequests.map(({ users }) =>
          users.map((user, i) => (
            <div key={i} className="user-photo">
              <PhotoContainer
                className="photo-container"
                image={user ? user.avatar : ''}
                defaultImg="user"
              />
            </div>
          ))
        )}
        <span className="text-red">{nameList}</span>
        <span>requested changes</span>
      </div>
    );
  } else {
    return null;
  }
};

export default Changes;



// WEBPACK FOOTER //
// src/components/Deals/DealEditPages/Changes.js